import React, { Fragment, useCallback } from 'react'

import { pluralize } from '../../helpers'
import { useTranslation } from '../../contexts/I18nContext'
import { COLORS, THEME } from '../../styles'

import Styled from './RatingStarsInput.styled'

const RatingStarsInput = ({ className, ratingScale, value, setValue }) => {
  const { t } = useTranslation()

  const handleChange = useCallback(
    (event) => {
      setValue(+event.target.value)
    },
    [setValue],
  )

  return (
    <Styled className={className}>
      <Styled.stars>
        {ratingScale.map((star) => (
          <Fragment key={star}>
            <Styled.input
              type="radio"
              id={`rating-star-${star}`}
              name="rating-star"
              value={star}
              checked={value === star}
              onChange={handleChange}
            />
            <Styled.label
              htmlFor={`rating-star-${star}`}
              title={pluralize(t('STAR'), star)}
            >
              <Styled.starStroke
                name="star-stroke-32"
                fill={THEME.COLORS.foreground.secondary}
                width={32}
                height={32}
                isHidden={value && value >= star}
              />
              <Styled.starFill
                name="star-fill-32"
                fill={COLORS.yolk}
                width={32}
                height={32}
                isHidden={value < star}
              />
            </Styled.label>
          </Fragment>
        ))}
      </Styled.stars>
    </Styled>
  )
}

RatingStarsInput.defaultProps = {
  ratingScale: [1, 2, 3, 4, 5],
  value: null,
}

export default RatingStarsInput
